import { Action } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { LoyaltyProgram } from '@rd/types/loyalty-program.type';

export enum RedeemCashLoyaltyProgramActionTypes {
  LOAD_REDEEM_CASH_LOYALTY_PROGRAM = '[RedeemCash] Load Redeem Cash Loyalty Program',
  LOAD_REDEEM_CASH_LOYALTY_PROGRAM_SUCCESS = '[RedeemCash] Load Redeem Cash Loyalty Program Success',
  LOAD_REDEEM_CASH_LOYALTY_PROGRAM_FAILED = '[RedeemCash] Load Redeem Cash Loyalty Program Failed',
}

export class LoadRedeemCashLoyaltyProgram implements Action {
  readonly type =
    RedeemCashLoyaltyProgramActionTypes.LOAD_REDEEM_CASH_LOYALTY_PROGRAM;
}

export class LoadRedeemCashLoyaltyProgramSuccess implements Action {
  readonly type =
    RedeemCashLoyaltyProgramActionTypes.LOAD_REDEEM_CASH_LOYALTY_PROGRAM_SUCCESS;

  constructor(public payload: LoyaltyProgram[]) {}
}

export class LoadRedeemCashLoyaltyProgramFailed implements Action {
  readonly type =
    RedeemCashLoyaltyProgramActionTypes.LOAD_REDEEM_CASH_LOYALTY_PROGRAM_FAILED;

  constructor(public payload: HttpError) {}
}

export type RedeemCashLoyaltyProgramActions =
  | LoadRedeemCashLoyaltyProgram
  | LoadRedeemCashLoyaltyProgramSuccess
  | LoadRedeemCashLoyaltyProgramFailed;
